export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14466.5374f695.jpg";